module.exports = __webpack_public_path__ + "static/media/paylane.5e12df26.png";